module.exports = __webpack_public_path__ + "img/bloodworks-logo.97898c49.png";